// extracted by mini-css-extract-plugin
export default {"FullScreenLoader":"FullScreenLoader_FullScreenLoader__ELfmP"};